var exports = {
  "kL": "BaseAvatar.module__container___NG5XWj",
  "vk": "BaseAvatar.module__clickable___NG5XWj",
  "Lw": "BaseAvatar.module__overlay___NG5XWj",
  "Sl": "BaseAvatar.module__image___NG5XWj",
  "qf": "BaseAvatar.module__placeholder___NG5XWj",
  "ci": "BaseAvatar.module__placeholderFastFade___NG5XWj",
  "Ap": "BaseAvatar.module__placeholderVisible___NG5XWj",
  "uR": "BaseAvatar.module__placeholderHidden___NG5XWj",
  "n_": "BaseAvatar.module__hoverOverlay___NG5XWj",
  "II": "BaseAvatar.module__statusContainer___NG5XWj",
  "mH": "BaseAvatar.module__statusTooltipDisabled___NG5XWj",
  "VN": "BaseAvatar.module__reducedMotion___NG5XWj",
  "BC": "BaseAvatar.module__animatedMaskShape___NG5XWj",
  "Qb": "BaseAvatar.module__animatedMaskReducedMotion___NG5XWj",
  "AP": "BaseAvatar.module__typingBubble___NG5XWj",
  "y5": "BaseAvatar.module__typingDots___NG5XWj",
  "BI": "BaseAvatar.module__typingDot___NG5XWj",
  "Zm": "BaseAvatar.module__blink___NG5XWj",
  "fQ": "BaseAvatar.module__customStatusBadge___NG5XWj",
  "Bp": "BaseAvatar.module__customStatusBadgeBackground___NG5XWj",
  "Go": "BaseAvatar.module__customStatusBadgeContent___NG5XWj",
};

module.exports = exports;
